import ApplicationConfig from '@/lib/application-config'
import storage from '@/lib/storage'
import store from '@/store'
import axios from 'axios'
import md5hex from 'md5hex'
import moment from 'moment'

class ConnectHttpBase {
  getAuthenticatedHttpClient() {
    return this.getHttpClient(this.getHttpAuthHeader())
  }

  getHttpClient(additionalHeaders = undefined) {
    let headers = this.getLangHeader()
    if (additionalHeaders) {
      headers = Object.assign(headers, additionalHeaders)
    }
    const httpClient = axios.create({
      headers: headers,
    })
    return httpClient
  }

  isAuthenticated() {
    let accessToken = this.getAccessToken()
    if (accessToken) {
      return true
    }
    return false
  }

  getAccessToken() {
    let token = store.getters.accessToken
    if (token) {
      if (this.isAccessTokenExpired()) {
        console.error('アクセストークン有効期限切れ')
        return undefined
      }
      return token
    }
    return undefined
  }

  isAccessTokenExpired() {
    let exp = moment(store.getters.accessTokenExpiredAt)
    if (exp) {
      const now = moment()
      return exp.isBefore(now)
    }
    return true
  }

  calclateSecretHash(userId) {
    let seed = userId + ApplicationConfig.getClientId() + ApplicationConfig.getClientSecret()
    seed = seed.toLowerCase()
    let charArray = seed.split('').sort()
    let value = charArray.join('')
    value = md5hex(value)
    return value
  }

  getHttpAuthHeader() {
    let token = 'Bearer ' + this.getAccessToken()
    return { Authorization: token }
  }

  getLangHeader() {
    const language = storage.getUserLangConsideringDefault()
    return { 'X-AID-Lang': language }
  }
}

let connectHttpBase = new ConnectHttpBase()
export default connectHttpBase
